import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import vue from '../../../../../adapter-vue';
import { TUIStore, IMessageModel } from '../../../../../@aidesk/uikit-engine';
import {
  isCustomerServicePluginMessage,
  isCustomServiceMessageInvisible,
} from './message-desk-elements/index';
import MessagePluginLayout from './message-plugin-layout-web.vue';
import MessageCustomerService from './message-desk-elements/message-desk.vue';
import { CUSTOM_MESSAGE_SRC } from '../../../../../constant';
import TimeoutWarning from './message-desk-elements/message-timeout-warning.vue';
import { customerServicePayloadType } from '../../../../../interface';
import { JSONToObject } from '../../../../../utils/index';
interface IProps {
  message: IMessageModel;
  blinkMessageIDList?: string[];
  enableFeedback: number;
  enableAINote: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'message-plugin-web',
  props: {
    message: { default: () => ({} as IMessageModel) },
    blinkMessageIDList: { default: () => [] as string[] },
    enableFeedback: { default: 0 },
    enableAINote: { default: 1 }
  },
  emits: [
  'resendMessage',
  'handleToggleMessageItem',
  'handleH5LongPress',
  'heightChanged',
  'messageSent',
  'like',
  'dislike',
],
  setup(__props: any, { emit: __emit }) {

const { computed } = vue;

const props = __props;

const emits = __emit;
const messageModel = computed(() => TUIStore.getMessageModel(props.message.ID));

const payload = computed<customerServicePayloadType>(() => {
  return props.message && JSONToObject(props.message?.payload?.data);
});

const pluginMessageType = computed<{ pluginType: string; showStyle: string }>(
  () => {
    let typeObj = { pluginType: '', showStyle: '' };
    if (isCustomerServicePluginMessage(messageModel.value as any)) {
      const src = payload.value.src;
      typeObj = {
        pluginType: src === CUSTOM_MESSAGE_SRC.TIMEOUT_WARNING ? 'customer_tip' : 'customer',
        showStyle: isCustomServiceMessageInvisible(messageModel.value as any)
          ? ''
          : src === CUSTOM_MESSAGE_SRC.TIMEOUT_WARNING
            ? 'tip'
            : 'bubble',
      };
    }
    return typeObj;
  },
);

// The following are for external interaction such as messageTool, no special processing is required, please do not touch
const resendMessage = (message: IMessageModel) => {
  emits('resendMessage', message);
};
const handleToggleMessageItem = (
  e: any,
  message: IMessageModel,
  isLongpress = false,
) => {
  emits('handleToggleMessageItem', e, message, isLongpress);
};
const handleH5LongPress = (e: any, message: IMessageModel, type: string) => {
  emits('handleH5LongPress', e, message, type);
};
const onHeightChanged = () => {
  emits('heightChanged');
};
const onMessageSent = () => {
  emits('messageSent');
};

function onLike(type: number, messageInfo: Object) {
  emits('like', type, messageInfo);
};

function onDislike(type: number, messageInfo: Object) {
  emits('dislike', type, messageInfo);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MessagePluginLayout, {
    message: props.message,
    blinkMessageIDList: props.blinkMessageIDList,
    showStyle: _unref(pluginMessageType).showStyle,
    bubbleClassNameList: [
      _unref(pluginMessageType).pluginType === 'room' ? 'message-bubble-room' : '',
    ],
    onResendMessage: resendMessage,
    onHandleToggleMessageItem: handleToggleMessageItem,
    onHandleH5LongPress: handleH5LongPress,
    enableFeedback: props.enableFeedback,
    enableAINote: props.enableAINote,
    onLike: onLike,
    onDislike: onDislike
  }, {
    messageBubble: _withCtx(() => [
      (_unref(pluginMessageType).pluginType === 'customer')
        ? (_openBlock(), _createBlock(MessageCustomerService, {
            key: 0,
            message: props.message,
            onHeightChanged: onHeightChanged,
            onMessageSent: onMessageSent
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ]),
    messageTip: _withCtx(() => [
      _createVNode(TimeoutWarning, { payload: _unref(payload) }, null, 8, ["payload"])
    ]),
    _: 1
  }, 8, ["message", "blinkMessageIDList", "showStyle", "bubbleClassNameList", "enableFeedback", "enableAINote"]))
}
}

})